const FPTI = {
  pgrp: 'main:merchanthub:partnerapps::main',
  page: 'main:merchanthub:partnerapps::main:::'
};

const FPTI_SELL_PAGE_NAME = 'detail:merchanthub:partnerapps::detail';

// miscellaneous constants
const MISC = {
  MYAPPS: 'myapps',
  FAVORITES: 'favorites',
  GETPAID: 'getpaid',
  MAKEPAYMENTS: 'makepayments',
  OPERATIONS: 'operations',
  INTEGRATE: 'integrate',
  SELL: 'sell',
  LEARN: 'learn',
  DISCOVER: 'discover',
  PAYMENTS: 'payments',
  BUSINESS: 'business',
  SELLING: 'selling',
  GROWING: 'growing',
  SHOPPING_CARTS: 'shoppingcarts',
  MARKETPLACES: 'marketplaces',
  WEBSITE_PLATFORMS: 'websiteplatforms',
  PAYPAL_IMAGES_LOC: 'https://paypalobjects.com/ppcp/images',
  ENTER_KEY: 'enter',
  ENTER_KEY_CODE: 13
};

const Survey = {
  POST_SURVEY_COMPLETE: 'POST_SURVEY_COMPLETE',
  ERROR_SURVEY_INPUT: 'ERROR_SURVEY_INPUT',
  CHANGE_SURVEY_COMPLETE: 'CHANGE_SURVEY_COMPLETE'
};

const SmartRec = {
  UPDATE_RECOMMENDED_TOOLS: 'UPDATE_RECOMMENDED_TOOLS'
};

const PartnerLinkConfigs = {
  wish: {
    client_id:
      'AS2mECBnGbbN72NWK_HHHnw2k6gsLXsfxm9eejD-0kj8me9LImZqWpnyntBq5iAkV0K5x48yJnkY_eYg',
    scope:
      'profile email https://uri.paypal.com/services/paypalattributes https://uri.paypal.com/services/paypalattributes/business',
    redirect_uri: 'https://www.merchant.wish.com/open?referrer=paypal'
  },
  grailed: {
    client_id:
      'AUjAnCPSNL0JXqwqhKbIsFfL2ZYR9qg8grcksg-3xrkIn0uoUTFvzllhaD4LMsDmfUGxJvR0UTVzDq7V',
    scope: 'email',
    redirect_uri: 'https://www.grailed.com/users/paypal-signup'
  },
  bonanza: {
    client_id:
      'AVt2-Fr2w7QVb7qxDp0gHohDqZFQKYB4MgUs4KULrN4zayXnwycugMykkE1zUjYJBsglaAWFGs_U8UEt',
    scope:
      'openid profile email address https://uri.paypal.com/services/paypalattributes https://uri.paypal.com/services/paypalattributes/business',
    redirect_uri: 'https://www.bonanza.com/paypal_otss/from_paypal'
  },
  swappa: {
    client_id:
      'AXQMYWIx2nnK3RLwJXl4gAs_tjaI7aKLOzC3DKq6uR4pC0a8qWSoQYwdxbijzsZE-ipiHncq9iNi3LbK',
    scope: 'profile email https://uri.paypal.com/services/paypalattributes',
    redirect_uri: 'https://swappa.com/complete/paypal/'
  },
  hood: {
    client_id:
      'AV6DL95Cvm9dDdTraf3F1Ntsr-sfElJoJDnjoglb94HlZtp1tfq3uroUc_Dwwab5PHzPJ4wG6_b05iuc',
    scope:
      'email profile openid https://uri.paypal.com/services/applications/webhooks https://uri.paypal.com/services/paypalattributes/business',
    redirect_uri: 'https://www.hood.de/anmeldung-paypal.htm'
  },
  onbuy: {
    client_id:
      'ATY4wIzfeMc7m6QbhLk5VaOaj7TbWz6ivTZXzS7P4CwMBrUuSKfeHK-Piricxc2LtG06m16yO8vmOjgP',
    scope:
      'email profile openid https://uri.paypal.com/services/paypalattributes/business',
    redirect_uri: 'https://www.onbuy.com/gb/sell/sign-up/paypal/?exta=ppal'
  },
  ecomdash: {
    client_id:
      'AZ4VeoV_rIn0F5QRgnqS4AS4b5y2bCBr8-DDmaTd0blwLFVrOQ1FCtUBSZP5QwgRkteTsoVd6xH_CHQo',
    scope:
      'profile email address https://uri.paypal.com/services/paypalattributes/business',
    redirect_uri: 'https://app.ecomdash.com/PayPal/GrantPayPalAccess',
    video_link: 'https://www.youtube.com/watch?v=bQfD8mtnT3Q'
  },
  walmart: {
    redirect_uri: 'https://www.paypal-business.com/walmart'
  },
  bigcommerce: {
    redirect_uri: 'https://www.bigcommerce.com/paypal-theme-offer/'
  },
  magento: {
    redirect_uri:
      'https://magento.com/schedule-a-demo?utm_source=PayPalResourcesDirectory&utm_medium=partnerlink&utm_campaign=PartnerResourcesMagento'
  },
  shopify: {
    redirect_uri:
      'https://www.shopify.com/paypalmerchants?utm_source=paypal&utm_medium=partner&utm_campaign=Resources Directory Shopify Home'
  },
  wix: {
    redirect_uri:
      'https://www.wix.com/eteamhtml/paypal?utm_campaign=bd_paypal^solutionproviders'
  },
  squarespace: {
    redirect_uri:
      'https://www.squarespace.com/?source=paypal-us&channel=bd&subchannel=paypal-resources'
  },
  woocommerce: {
    redirect_uri:
      'https://woocommerce.com/woocommerce-and-paypal/?utm_source=PayPal Resources&utm_medium=partner link&utm_campaign=Resources Directory WooCommerce'
  }
};

const PartnerBulletPoints = {
  wish: ['valueProps', 'costProps'],
  grailed: ['valueProps', 'costProps'],
  swappa: ['valueProps', 'costProps'],
  bonanza: ['valueProps', 'costProps'],
  hood: ['valueProps', 'costProps'],
  onbuy: ['valueProps', 'costProps']
};

const tabRouteNames = [
  MISC.MYAPPS,
  MISC.FAVORITES,
  MISC.GETPAID,
  MISC.MAKEPAYMENTS,
  MISC.OPERATIONS,
  MISC.INTEGRATE,
  MISC.SELL,
  MISC.LEARN,
  MISC.WEBSITE_PLATFORMS
];

const ROUTE_TO_CATEGORY = {
  myapps: MISC.DISCOVER,
  makepayments: MISC.PAYMENTS,
  operations: MISC.BUSINESS,
  sell: MISC.SELLING,
  learn: MISC.GROWING,
  favorites: MISC.FAVORITES,
  getpaid: MISC.GETPAID,
  integrate: MISC.INTEGRATE,
  websiteplatforms: MISC.SHOPPING_CARTS
};

const MARKETPLACES = ['wish', 'bonanza', 'swappa', 'grailed', 'hood', 'onbuy'];
const PARTNERS = ['wish', 'bonanza', 'swappa', 'grailed', 'hood', 'onbuy'];

// There is difference between naming from PS
// for bigcommerce and big_commerce
const EXTERNAL_PARTNERS = [
  'walmart',
  'bigcommerce',
  'magento',
  'shopify',
  'wix',
  'squarespace',
  'woocommerce'
];

const ROUTES = {
  sell: PARTNERS
};

const HELPFUL = {
  selling: '',
  bonanza: ''
};

const PARTNER_DETAIL_ICONS = {
  wish: ['recommended', 'offer'],
  onbuy: ['recommended', 'offer']
};

const DISCOVER_DYNAMIC_SUBCATEGORY_PRIORITIZATION = {
  topPicks: {
    useSegment: false,
    useRecommendations: true,
    recommendedTools: [
      'pp_buttons',
      'pp_multi_order_shipping',
      'pp_resolution_center',
      'pp_send_money',
      'pp_request_money'
    ]
  },
  popular: {
    useSegment: false,
    useRecommendations: false,
    recommendedTools: [
      'pp_buttons',
      'pp_multi_order_shipping',
      'pp_invoicing',
      'pp_business_setup',
      'pp_recurring_payments',
      'pp_here',
      'pp_request_money',
      'pp_send_money',
      'pp_api_access',
      'pp_resolution_center',
      'pp_shipping_calculator',
      'pp_debitcard'
    ]
  }
};

const QUIZ_CONSTANTS = {
  numberOfQuestions: 4,
  developer: 'developer',
  feedback: {
    yes: 'yes',
    no: 'no',
    maxCount: 200,
    feedbackTitle: 'Thanks for your feedback. Any comments?'
  }
};

const PARTNERS_TITLE = 'partners';
const MARKETPLACES_TITLE = 'marketplaces';
const BIG_COMMERCE = 'big_commerce';
const RECOMMEND_CATEGORY_NAME = 'recommended_for_you';
const CHECKOUT = 'pp_express_checkout';
const WALMART = 'walmart';
const IZETTLE = 'pp_izettle';

export default {
  Survey,
  SmartRec,
  FPTI,
  FPTI_SELL_PAGE_NAME,
  MISC,
  PartnerLinkConfigs,
  tabRouteNames,
  ROUTES,
  PartnerBulletPoints,
  HELPFUL,
  PARTNERS,
  MARKETPLACES,
  EXTERNAL_PARTNERS,
  PARTNER_DETAIL_ICONS,
  DISCOVER_DYNAMIC_SUBCATEGORY_PRIORITIZATION,
  ROUTE_TO_CATEGORY,
  QUIZ_CONSTANTS,
  RECOMMEND_CATEGORY_NAME,
  PARTNERS_TITLE,
  MARKETPLACES_TITLE,
  BIG_COMMERCE,
  CHECKOUT,
  WALMART,
  IZETTLE
};

export {
  Survey,
  SmartRec,
  FPTI,
  FPTI_SELL_PAGE_NAME,
  MISC,
  PartnerLinkConfigs,
  tabRouteNames,
  ROUTES,
  PartnerBulletPoints,
  HELPFUL,
  PARTNERS,
  MARKETPLACES,
  EXTERNAL_PARTNERS,
  PARTNER_DETAIL_ICONS,
  DISCOVER_DYNAMIC_SUBCATEGORY_PRIORITIZATION,
  ROUTE_TO_CATEGORY,
  QUIZ_CONSTANTS,
  RECOMMEND_CATEGORY_NAME,
  PARTNERS_TITLE,
  MARKETPLACES_TITLE,
  BIG_COMMERCE,
  CHECKOUT,
  WALMART,
  IZETTLE
};
